module.exports = __webpack_public_path__ + "img/progress_086.8f04149d.png";